function mapLoaded() {
    var latLng = new google.maps.LatLng(window.mapLat, window.mapLng),
        mapOptions = {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            center: latLng,
            zoom: 15,
            zoomControl: true,
            scrollwheel: false
        },
        map = new google.maps.Map($('#map').get(0), mapOptions),
        icon = {
            url: '/images/map-hq.png',
            anchor: new google.maps.Point(40, 80),
            scaledSize: new google.maps.Size(80, 80)
        },
        marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: icon,
            optimized: false
        });
}
